import React from "react";
import { fmt2 } from "@/lib/api";

export default function PriceBreakdown({ base, fee, total, currency = "USD", subtle = false, testidPrefix = "price-breakdown" }) {
  return (
    <div className={`rounded-xl ${subtle ? "bg-muted/70" : "bg-muted"} border border-border p-3 text-sm`} data-testid={`${testidPrefix}`}> 
      <div className="flex items-center justify-between">
        <span className="text-muted-foreground">Base price</span>
        <span data-testid={`${testidPrefix}-base`}>{fmt2(base, currency)}</span>
      </div>
      <div className="flex items-center justify-between mt-1">
        <span className="text-muted-foreground">Marketplace fee (10%)</span>
        <span data-testid={`${testidPrefix}-fee`}>{fmt2(fee, currency)}</span>
      </div>
      <div className="flex items-center justify-between pt-2 mt-2 border-t border-border font-semibold">
        <span>Total</span>
        <span data-testid={`${testidPrefix}-total`}>{fmt2(total, currency)}</span>
      </div>
    </div>
  );
}
